// extracted by mini-css-extract-plugin
module.exports = {"link":"b7635b5199--link--xaKpq","link--phone":"b7635b5199--link--phone--goh_E","link-disabled":"b7635b5199--link-disabled--KZiA6"};